/**
 * Progress line animations
 * Shared keyframe animations for progress line components
 */

import { PROGRESS_LINE_CONSTANTS } from '../constants';

/**
 * Background line entrance animation
 */
export const backgroundLineEntranceAnimation = {
  '@keyframes backgroundLineEntrance': {
    '0%': {
      opacity: 0,
      transform: 'translateY(-50%) scaleX(0)',
    },
    '100%': {
      opacity: 1,
      transform: 'translateY(-50%) scaleX(1)',
    },
  },
};

/**
 * Completed progress line animations
 */
export const completedProgressAnimations = {
  '@keyframes progressFillCompleted': {
    '0%': { width: 0 },
    '100%': { width: 'var(--target-width)' },
  },
  '@keyframes progressShine': {
    '0%': { transform: 'translateX(-100%)', opacity: 0 },
    '50%': { opacity: 1 },
    '100%': { transform: 'translateX(100%)', opacity: 0 },
  },
};

/**
 * Current segment progress animations
 */
export const currentProgressAnimations = {
  '@keyframes progressFillCurrent': {
    '0%': { width: 0 },
    '100%': { width: 'var(--target-width)' },
  },
  '@keyframes progressPulse': {
    '0%': { transform: 'translateY(-50%) scaleY(1)' },
    '100%': {
      transform: `translateY(-50%) scaleY(${PROGRESS_LINE_CONSTANTS.SCALE.NORMAL_PULSE})`,
    },
  },
  '@keyframes progressGlow': {
    '0%, 100%': { opacity: PROGRESS_LINE_CONSTANTS.OPACITY.GLOW_MIN },
    '50%': { opacity: PROGRESS_LINE_CONSTANTS.OPACITY.GLOW_MAX },
  },
};

/**
 * Error progress animations
 */
export const errorProgressAnimations = {
  '@keyframes progressFillError': {
    '0%': { width: 0 },
    '100%': { width: 'var(--target-width)' },
  },
  '@keyframes errorPulse': {
    '0%': {
      transform: 'translateY(-50%) scaleY(1)',
      filter: 'brightness(1)',
    },
    '100%': {
      transform: `translateY(-50%) scaleY(${PROGRESS_LINE_CONSTANTS.SCALE.ERROR_PULSE})`,
      filter: `brightness(${PROGRESS_LINE_CONSTANTS.SCALE.BRIGHTNESS_ERROR})`,
    },
  },
  '@keyframes errorBlink': {
    '0%, 100%': { opacity: PROGRESS_LINE_CONSTANTS.OPACITY.ERROR_BLINK_MIN },
    '50%': { opacity: PROGRESS_LINE_CONSTANTS.OPACITY.ERROR_BLINK_MAX },
  },
};
